import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaUsers } from 'react-icons/fa';
import { Box, Stack, Typography } from '@mui/material';
import { isEmpty } from 'lodash';

import type { FilterGroups } from 'src/components/app/context/FilterContext';
import { useFilterContext } from 'src/components/app/context/FilterContext';
import ButtonModal from 'src/components/common/ButtonModal';
import FractionDisplay from 'src/components/planAction/PlanActionStatisticsPage/components/ActionPlanCoverage/components/FractionDisplay';

import { styles } from './index.styles';

interface Props {
  totalHeadcount?: number;
  coveredHeadcount?: number;
  fractionLabel?: string;
  bigText?: boolean;
}

// See #531 - If any filter is set it should return true as the calculation is wrong
// and they currently do not want to fix it
const shouldShowNA = (filters: FilterGroups) => {
  const filtersWithoutOrgUnit = Object.fromEntries(
    Object.entries(filters).filter(([key]) => key !== 'orgUnit'),
  );

  return !isEmpty(filtersWithoutOrgUnit);
};

export const HeadcountCoverage: FC<Props> = ({
  totalHeadcount = 0,
  coveredHeadcount = 0,
  fractionLabel = '',
  bigText,
}) => {
  const { t } = useTranslation('planAction');
  const { filterGroups } = useFilterContext();

  return (
    <Box>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          mb: 1,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: bigText ? 30 : 20,
          }}
        >
          {t('Statistics.Coverage.CoveredEmployees')}
        </Typography>
        <ButtonModal
          headline={t('Statistics.Coverage.CoveredEmployees')}
          text={t('Statistics.Coverage.CoveredEmployeesHelp')}
        />
      </Stack>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        <FractionDisplay
          nominator={coveredHeadcount}
          denominator={totalHeadcount}
          showNA={shouldShowNA(filterGroups)}
          label={fractionLabel}
          bigText={bigText}
        />
        <Box sx={styles.iconWrapper}>
          <FaUsers />
        </Box>
      </Stack>
    </Box>
  );
};
